<h1 mat-dialog-title>
  {{ data.title }}
</h1>

@if (data?.text) {
<mat-dialog-content>
  @for (mes of data.text; track $index) {
  <div [innerHTML]="parse(mes)"></div>
  }
</mat-dialog-content>
}

<mat-dialog-actions align="end">
  @for (button of data.buttons; track $index) {
  <button
    [color]="button.color"
    [mat-dialog-close]="button.value"
    color="primary"
    mat-button
  >
    @if (button.icon) {
    <mat-icon>
      {{ button.icon }}
    </mat-icon>
    }
    {{ button.text }}
  </button>
  }
</mat-dialog-actions>
